import { useEffect, useRef, useState } from "react"

import { telegram } from "@/shared/lib/telegram"

/**
 * Shows Telegram Mini App native BackButton (header close → back) and hides the
 * in-app back affordance. Retries briefly while WebApp attaches (same race as telegram.ts).
 */
export function useTelegramBackButton(onBack: () => void): boolean {
  const onBackRef = useRef(onBack)
  onBackRef.current = onBack

  const [useNativeBack, setUseNativeBack] = useState(() => telegram.isAvailable)

  useEffect(() => {
    if (telegram.isAvailable) {
      setUseNativeBack(true)
      return
    }

    let attempts = 0
    const timerId = window.setInterval(() => {
      attempts += 1
      if (telegram.isAvailable) {
        setUseNativeBack(true)
        window.clearInterval(timerId)
      } else if (attempts >= 15) {
        window.clearInterval(timerId)
      }
    }, 200)

    return () => window.clearInterval(timerId)
  }, [])

  useEffect(() => {
    if (!useNativeBack) return

    const handler = () => onBackRef.current()
    telegram.showBackButton(handler)
    return () => telegram.hideBackButton(handler)
  }, [useNativeBack])

  return useNativeBack
}
